"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.maskUrlSearchParameters = exports.appendProductToURL = exports.detectProductReferral = exports.detectPage = void 0;
const Common_1 = require("./Common");
const Logger_1 = __importDefault(require("./Logger"));
const DEFAULT_PORT_MAP = {
    http: 80,
    https: 443,
};
function detectUrlFragments(host, referrer) {
    var _a, _b;
    const props = {
        page_urlhost: host.hostname,
        page_url_params: host.search,
        page_urlpath: host.pathname,
        page_urlscheme: host.protocol.slice(0, -1).toLowerCase(), // remove the trailing ":",,
    };
    props.page_urlport = (_a = (host.port || DEFAULT_PORT_MAP[props.page_urlscheme])) === null || _a === void 0 ? void 0 : _a.toString();
    if (referrer) {
        props.page_referrer_urlscheme = referrer.protocol.slice(0, -1).toLowerCase(); // remove the trailing ":"
        props.page_referrer_urlport = (_b = (referrer.port || DEFAULT_PORT_MAP[props.page_referrer_urlscheme])) === null || _b === void 0 ? void 0 : _b.toString();
        props.page_referrer_urlpath = referrer.pathname;
        props.page_referrer_urlhost = referrer.hostname;
    }
    return props;
}
function detectUtm({ searchParams }) {
    let facets = null;
    Common_1.UTM_PARAMETERS.forEach((parameter) => {
        const tag = searchParams.get(parameter);
        if (!tag)
            return;
        if (!facets) {
            facets = {};
        }
        facets[parameter] = tag;
    });
    return facets;
}
function detectPage(base, referrer) {
    const url = new URL(base);
    return Object.assign(Object.assign({ path: url.pathname, url: url.toString(), properties: detectUrlFragments(url, referrer ? new URL(referrer) : undefined) }, (url.search ? { search: url.search } : undefined)), detectUtm(url));
}
exports.detectPage = detectPage;
const REFERRER_PARAMETERS = [
    ["REFERRER_ID", "adp_referrer_id"],
    ["REFERRER_NAME", "adp_referrer_name"],
    ["REFERRER_SESSION_ID", "adp_referrer_session"],
    ["REFERRER_VERSION", "adp_referrer_version"],
];
function detectProductReferral(base) {
    const url = new URL(base);
    const { searchParams } = url;
    let facets = null;
    let emptyCount = 0;
    REFERRER_PARAMETERS.forEach(([facetKey, searchKey]) => {
        const value = searchParams.get(searchKey);
        if (!value) {
            emptyCount += 1;
            return;
        }
        if (!facets) {
            facets = {};
        }
        facets[facetKey] = value;
    });
    if (emptyCount !== REFERRER_PARAMETERS.length) {
        Logger_1.default.warn("Referrer is incomplete");
    }
    return facets;
}
exports.detectProductReferral = detectProductReferral;
function appendProductToURL(base, product, session) {
    const url = new URL(base);
    const search = new URLSearchParams(url.search);
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { id, name, build_id } = product;
    search.set("adp_referrer_id", id);
    search.set("adp_referrer_name", name);
    if (session) {
        search.set("adp_referrer_session", session);
    }
    if (build_id) {
        search.set("adp_referrer_version", build_id);
    }
    url.search = search.toString();
    return url.toString();
}
exports.appendProductToURL = appendProductToURL;
function maskUrlSearchParameters(...filters) {
    const stringFilter = filters.reduce((state, filter) => {
        switch (typeof filter) {
            case "string": {
                return state.add(filter);
            }
            default: {
                return state;
            }
        }
    }, new Set());
    const regexFilters = filters.filter((filter) => filter instanceof RegExp);
    let memo;
    const findAndReplaceRestrictedParameters = (searchParams) => {
        if (memo && memo.toString() === searchParams.toString())
            return new URLSearchParams(memo);
        const entries = Array.from(searchParams.entries()).map(([key, value]) => {
            if (stringFilter.has(key) || regexFilters.some((pattern) => pattern.test(key))) {
                return [key, "****"];
            }
            return [key, value];
        });
        const result = new URLSearchParams(entries);
        if (entries.length > 0) {
            memo = result;
        }
        return result;
    };
    return ((base) => {
        if (base instanceof URLSearchParams) {
            return findAndReplaceRestrictedParameters(base);
        }
        const baseURL = new URL(base);
        const url = new URL(baseURL);
        url.search = findAndReplaceRestrictedParameters(baseURL.searchParams).toString();
        return url;
    });
}
exports.maskUrlSearchParameters = maskUrlSearchParameters;
